import { useState } from 'react'
import { useMemoizedFn } from 'ahooks'
import arrayMove from 'array-move'

export default ({ quickSearchOptions, onOk }) => {
    const [list, seyList] = useState([])

    const init = useMemoizedFn(() => {
        seyList(quickSearchOptions)
    })

    const handleSortEnd = ({ oldIndex, newIndex }) => {
        const newValue = arrayMove(list, oldIndex, newIndex)

        seyList(newValue)
    }

    const submit = useMemoizedFn(() => {
        onOk({ list })
    })

    return {
        init,
        list,
        handleSortEnd,
        submit
    }
}
